"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Grantee = {
    type: "structure",
    required: ["Type"],
    members: {
        DisplayName: {
            shape: {
                type: "string"
            }
        },
        EmailAddress: {
            shape: {
                type: "string"
            }
        },
        ID: {
            shape: {
                type: "string"
            }
        },
        Type: {
            shape: {
                type: "string"
            },
            locationName: "xsi:type",
            xmlAttribute: true
        },
        URI: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Grantee.js.map